<template>
  <div></div>
</template>

<script type="text/babel">
import EventBus from "../../../imports/event-bus";

export default {
  props: {
    brandName: {
      required: true,
    },
    promptText: {
      required: true,
    },
  },

  data() {
    return {
      initialised: false,
    };
  },

  watch: {
    promptText() {
      this.toast();
    },
  },

  mounted() {
    EventBus.$on("service-type-changed", () => {
      this.toast();
    });

    this.toast();
  },

  unmounted() {
    window.toastr.remove();
  },

  methods: {
    toast() {
      if (!this.promptText || this.promptText.length === 0) {
        return;
      }

      window.toastr.info(
        this.promptText.replace(/\r\n|\r|\n/g, "<br>"),
        `Brand Prompt: ${this.brandName}`,
        {
          positionClass: "toast-top-left toast-prompt",
          timeOut: 0,
          extendedTimeOut: 0,
          closeButton: true,
          newestOnTop: true,
        }
      );
    },
  },
};
</script>
